module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("编辑收货地址")])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your name"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "phoneNumber",
      "placeholder": "Phone Number"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "password",
      "placeholder": "area"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-gender"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('select', [_c('option', [_vm._v("Male")]), _vm._v(" "), _c('option', [_vm._v("Female")])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Birthday")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "date",
      "placeholder": "Birth day",
      "value": "2014-04-30"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-toggle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Switch")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-comment"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("Textarea")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Submit")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1de7c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/Detail/AddressDetail.vue
// module id = 1559
// module chunks = 8